var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-element-text-top"},[_c('div',{staticClass:"left"},[_c('span',[_vm._v("我：")]),_c('span',[_vm._v(_vm._s(_vm.content))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }